export enum StatusType
{
    Approval,
    Edit,
    Decision,
    AwaitingAutomaticTransition,
    EndNode

}